import { Map } from 'immutable'

export const UPDATE_CONTRATO_DEMANDA_INSTALACAO_SELECTION = 'UPDATE_CONTRATO_DEMANDA_INSTALACAO_SELECTION'
export function updateContratoDemandaInstalacaoSelection(property, value) {
  return {
    type: UPDATE_CONTRATO_DEMANDA_INSTALACAO_SELECTION,
    property,
    value,
  }
}

const initialState = Map({
  year: (new Date()).getFullYear(),
  years: function() {
    let arr = []
    const currentYear = (new Date()).getFullYear()
    for (let year = currentYear; year >= 2013; year--) {
      arr.push({
        key: `${year}`,
        text: `${year}`,
        value: year
      })
    }
    return arr
  }(),
})

export default function contratoDemandaInstalacaoSelection (state = initialState, action) {
  switch (action.type) {

    case UPDATE_CONTRATO_DEMANDA_INSTALACAO_SELECTION : {
      const { property, value } = action

      switch (property) {
        case 'year':
          state = state.set('year', value)
          break

        default:
          break
      }

      return state
    }

    default :
      return state
  }
}
